import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { Modal } from '@domain-group/fe-co-allhomes-design-system';
import { pushToDataLayer } from '@domain-group/fe-helper';
import AllhomesEnquiryForm from '../../allhomes-enquiry-form';
import * as styles from './agent-enquiry-form.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var optionsAgency = [{
  id: 'SELLING',
  value: 'SELLING_PROPERTY',
  label: "I'm selling a property"
}, {
  id: 'BUYING',
  value: 'BUYING_PROPERTY',
  label: "I'm looking to buy a property"
}, {
  id: 'RENTING',
  value: 'RENTING_PROPERTY',
  label: "I'm looking to rent a property"
}, {
  id: 'APPRAISAL',
  value: 'PROPERTY_APPRAISAL',
  label: "I'd like a property appraisal"
}, {
  id: 'LEASING',
  value: 'LEASING_PROPERTY',
  label: "I'm leasing a property"
}, {
  id: 'NONE',
  value: 'NONE_OF_ABOVE',
  label: 'None of above'
}];
var sendToDataLayer = emailHash => {
  pushToDataLayer({
    event: 'GAevent',
    eventCategory: 'Conversion',
    eventAction: 'Email Enquiry - Find an Agent',
    eventLabel: 'Agent Banner',
    user: {
      emailHash
    }
  });
};
export var AgentEnquiryForm = _ref => {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'agent' : _ref$appearance,
    _ref$logoUrl = _ref.logoUrl,
    logoUrl = _ref$logoUrl === void 0 ? null : _ref$logoUrl,
    _ref$clientId = _ref.clientId,
    clientId = _ref$clientId === void 0 ? null : _ref$clientId,
    _ref$closeCallback = _ref.closeCallback,
    closeCallback = _ref$closeCallback === void 0 ? () => {} : _ref$closeCallback,
    _ref$submitFormCallba = _ref.submitFormCallback,
    submitFormCallback = _ref$submitFormCallba === void 0 ? () => {} : _ref$submitFormCallba,
    _ref$agencies = _ref.agencies,
    agencies = _ref$agencies === void 0 ? [] : _ref$agencies,
    _ref$agents = _ref.agents,
    agents = _ref$agents === void 0 ? [] : _ref$agents,
    _ref$checkedOptions = _ref.checkedOptions,
    checkedOptions = _ref$checkedOptions === void 0 ? [] : _ref$checkedOptions,
    clientType = _ref.clientType,
    endpointUrl = _ref.endpointUrl,
    formTitle = _ref.formTitle,
    listingAddress = _ref.listingAddress,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? optionsAgency : _ref$options;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  var handleEnquirySent = emailHash => {
    try {
      sendToDataLayer(emailHash);
    } catch (error) {}
    submitFormCallback(emailHash);
  };
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(Modal, {
    onClose: closeCallback,
    show: true,
    fitContent: !mobile,
    showHeader: mobile,
    title: mobile ? formTitle : undefined
  }, ___EmotionJSX(AllhomesEnquiryForm, {
    formTitle: mobile ? undefined : formTitle,
    endpointUrl: endpointUrl,
    logoUrl: logoUrl,
    appearance: appearance,
    doneText: "Close",
    onDoneClick: closeCallback,
    onEnquirySent: handleEnquirySent,
    enableMessage: true,
    messagePlaceholder: "Write your message",
    formData: {
      id: clientId,
      type: clientType
    },
    options: options,
    agencies: agencies,
    agents: agents,
    checkedOptions: checkedOptions,
    listingAddress: listingAddress
  })));
};